var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "#E2E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.626 34.86h25.745V20.126H7.626v14.736Zm2.369-10.587a2.068 2.068 0 0 0 2.067-2.068h16.873a2.068 2.068 0 0 0 2.068 2.068v6.434a2.068 2.068 0 0 0-2.068 2.068H12.062a2.066 2.066 0 0 0-2.067-2.068v-6.434Z",
    fill: "#F88360"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.498 30.595a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204Z",
    fill: "#F88360"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.979 19.093h25.425v11.894l2.077-.22-1.54-14.65-25.962 2.976Z",
    fill: "#F88360"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m36.474 12.15-26.1 5.509 25.481-2.677 1.279 12.155 2.117-.509-2.777-14.479Z",
    fill: "#F88360"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.213fefd8c9ba236b78fcb1473a694737.svg";
export { ForwardRef as ReactComponent };